/* Circuit Afrique : (1) zone de livraison du panier (« Livrer en »), (2) fenêtre modale « Commander depuis l'Afrique » (WhatsApp Business).
   Maquette : js/afrique.js. Aucun message à l'arrivée sur le site : l'orientation apparaît au panier, au moment de l'adresse, et aux liens « Tu es en Afrique ? ».
   (1) La zone = choix mémorisé de la visiteuse (localStorage), sinon zone par défaut du pays de son marché (attribut data-zone-default rendu par Liquid, snippet mi-ship-zone).
       Le CSS (mi-pages-afrique.css) affiche le message et remplace le bouton de paiement quand html[data-ship-zone="afrique"].
   (2) Modale rendue une fois par page (snippet mi-africa-modal) ; ouverte par [data-africa-open] ; lien WhatsApp = réglage de thème. */
(() => {
  if (window.__miAfricaInit) return;
  window.__miAfricaInit = true;

  const KEY = 'mi-ship-zone';
  const ZONES = ['france', 'europe', 'afrique', 'autre'];
  const store = {
    get() { try { return localStorage.getItem(KEY); } catch (e) { return null; } },
    set(v) { try { localStorage.setItem(KEY, v); } catch (e) { /* stockage indisponible : le choix ne sera pas mémorisé */ } },
  };

  /* ---------- (1) Zone du panier ---------- */
  function currentZone() {
    const saved = store.get();
    if (ZONES.includes(saved)) return saved;
    const d = document.querySelector('[data-zone-default]');
    const v = d && d.getAttribute('data-zone-default');
    return ZONES.includes(v) ? v : 'france';
  }
  function applyZone() {
    const z = currentZone();
    document.documentElement.dataset.shipZone = z;
    document.querySelectorAll('[data-zone-select]').forEach((s) => { if (s.value !== z) s.value = z; });
  }
  document.addEventListener('change', (e) => {
    const s = e.target.closest && e.target.closest('[data-zone-select]');
    if (!s || !ZONES.includes(s.value)) return;
    store.set(s.value);
    applyZone();
    document.dispatchEvent(new CustomEvent('mi:zone', { detail: s.value }));
  });
  /* Le panier est redessiné par le rendu de sections après chaque changement de quantité : on réapplique le choix. */
  let raf = 0;
  new MutationObserver(() => { cancelAnimationFrame(raf); raf = requestAnimationFrame(applyZone); }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('mi:cart', () => setTimeout(applyZone, 0));
  applyZone();

  /* ---------- (2) Fenêtre modale ---------- */
  const modal = document.querySelector('[data-africa-modal]');
  if (!modal) return;
  const dialog = modal.querySelector('.afm__dialog');
  const root = document.documentElement;
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let opener = null;
  let openTimer = 0;

  function open(trigger) {
    opener = trigger || document.activeElement;
    clearTimeout(openTimer);
    modal.hidden = false;
    root.classList.add('afm-lock');
    void modal.offsetWidth;
    modal.classList.add('is-open');
    dialog.focus({ preventScroll: true });
    const first = modal.querySelector('.afm__x');
    if (first) first.focus({ preventScroll: true });
  }
  function close() {
    if (modal.hidden) return;
    modal.classList.remove('is-open');
    const done = () => { modal.hidden = true; root.classList.remove('afm-lock'); };
    if (reduce()) done(); else openTimer = setTimeout(done, 320);
    if (opener && opener.isConnected && opener.focus) opener.focus({ preventScroll: true });
    opener = null;
  }

  document.addEventListener('click', (e) => {
    const t = e.target.closest && e.target.closest('[data-africa-open]');
    if (t) { e.preventDefault(); open(t); return; }
    if (e.target.closest && e.target.closest('[data-africa-close]') && !modal.hidden) { e.preventDefault(); close(); return; }
    const cp = e.target.closest && e.target.closest('[data-africa-copy]');
    if (cp) {
      const num = modal.querySelector('[data-africa-num]');
      const live = modal.querySelector('[data-africa-live]');
      const text = num ? num.textContent.trim() : '';
      const ok = () => { if (live) { live.textContent = ''; setTimeout(() => { live.textContent = modal.dataset.copied || ''; }, 30); } const l = cp.textContent; cp.textContent = modal.dataset.copied || l; setTimeout(() => { cp.textContent = l; }, 1800); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(ok).catch(() => {});
      else { const r = document.createRange(); r.selectNodeContents(num); const s = window.getSelection(); s.removeAllRanges(); s.addRange(r); try { document.execCommand('copy'); ok(); } catch (err) { /* sélection laissée */ } }
    }
  });
  // Capture : Échap et Tab appartiennent à la fenêtre tant qu'elle est ouverte (le tiroir panier ne doit pas se fermer en dessous).
  window.addEventListener('keydown', (e) => {
    if (modal.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); close(); return; }
    if (e.key !== 'Tab') return;
    const items = Array.from(dialog.querySelectorAll(FOCUSABLE)).filter((el) => el.offsetParent !== null);
    if (!items.length) { e.preventDefault(); return; }
    const first = items[0]; const last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!dialog.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  }, true);
  document.addEventListener('focusin', (e) => {
    if (!modal.hidden && modal.classList.contains('is-open') && !dialog.contains(e.target)) { const x = modal.querySelector('.afm__x'); if (x) x.focus({ preventScroll: true }); }
  });
})();
